<div class="contract-control-step-five">
    <h2 class="step-heading-title">Contacts</h2>

    <div class="input-group input-group-merge mb-1">
        <div class="input-group-prepend">
            <span class="input-group-text"><i data-feather="search"></i></span>
        </div>
        <ng-autocomplete class="form-control CC_autoCompleteSearch px-0" #auto 
            [data]="searchedRecipient" (inputChanged)="searhContacts($event)" 
            (inputCleared)="onClearSearch()" [searchKeyword]="keyword"
            placeholder="Search contacts" (selected)="selectContact($event);auto.clear()" [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" 
            [isLoading]="loading">
        </ng-autocomplete>
        <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.firstname +' '+ (item?.lastname ?? '') + '<br>' + item.email"></a>
        </ng-template>
        <ng-template #notFoundTemplate let-notFound>
            <div [innerHTML]="notFound"></div>
        </ng-template>
    </div>

    <div class="card card-transaction CC_contactsContainer mb-0" [formGroup]="mainFormGroup">
        <ng-container formArrayName="contacts">
          <div class="transaction-item contactsListHover" *ngFor="let contact of contactsControl.controls; let i = index;">
            <div [formGroupName]="i">
              <div class="media">
                <div class="avatar me-1">
                  <span class="avatar-content">{{ getFullName(contact) | shortName }}</span>
                </div>
                <div class="media-body">
                  <h6 class="transaction-title">{{ getFullName(contact) }}</h6>
                  <small>{{ contact?.value?.email }}</small>
                </div>
                
              </div>
            </div>
            <div class="fw-bolder listOptionHide">
              <div class="text-danger font-small-2 cursor-pointer" (click)="removeContact(i)">Delete</div>
              <div>
                <a class="text-secondary" href="mailto:{{ contact?.value?.email }}"><i class="font-medium-2 cursor-pointer me-50" data-feather="mail"></i></a>
                <a class="text-secondary" href="tel:{{ contact?.value?.phone_no }}"> <i class="font-medium-2 cursor-pointer" data-feather="phone-call"></i></a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
</div>
